import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { VerificationService } from '../../../Model/Verification/verification.service';
import { EmployeeRegistrationService } from '../../../Model/EmployeeRegistration/employee-registration.service';
import { CommonService } from '../../../Model/Common/common.service';
import { AadhaarKYCDigilockerComponent } from '../../AadhaarKYCDigilocker/aadhaar-kycdigilocker/aadhaar-kycdigilocker.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { interval } from 'rxjs'

@Component({
  selector: 'app-aadhaar-kyc',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './aadhaar-kyc.component.html',
  styleUrl: './aadhaar-kyc.component.scss'
})
export class AadhaarKYCComponent {
  isDisabled: boolean = false;
  @Input() EmpMasterId: number = 0;
  @Input() EmpType: String = '';
  @Input() AadhaarNo: String = '';
  timer: any;
  timingsixty = 60;
  otpButtonDisable = false;
  IsOkyc = true;
  AadhaarDetail = {
    AadhaarNo: null as any,
    OTP: null,
    SendOTP: false,
    AadharrequestId: null,
    AADHAARVerificationID: null,
    AadharVerificationStatus: null as any
  }

  ReturnDetail = {
    AadharrequestId: null as any,
    AADHAARVerificationID: null,
    AadharVerificationStatus: null,
    AadharNoKyc: null,
    NameAsPerAadhaar: null,
    BirthDate: null,
    Gender: null as any,
    photo: null as any,
    LocalAddress1: null as any,
    LocalAddress2: null as any,
    AadhaarNo: null,
  }

  constructor(
    private toast: ToastService,
    private activeModal: NgbActiveModal,
    private verification: VerificationService,
    private employeeRegistration: EmployeeRegistrationService,
    protected common: CommonService,
    private modalService: NgbModal,
  ) { }

  ngOnInit() {
    if (this.AadhaarNo != null && this.AadhaarNo != "") {
      this.AadhaarDetail.AadhaarNo = this.AadhaarNo;
    }
  }

  Verification(form: any) {
    if (form.valid) {
      this.isDisabled = true;
      if (!this.AadhaarDetail.SendOTP) {
        this.PanAadharBankDuplicate('CheckAadhaar', this.AadhaarDetail.AadhaarNo);
      } else {
        this.verification.OKYCOTPVerify({ 'VerifyoTP': this.AadhaarDetail.OTP, 'requestId': this.AadhaarDetail.AadharrequestId }).subscribe({
          next: (response) => {
            response = JSON.parse(response);
            this.SaveVerification('Aadhaar Card KYC', this.AadhaarDetail.AadharrequestId, JSON.stringify(response), response.success);
            if (response.success) {
              this.ReturnDetail.AadharrequestId = this.AadhaarDetail.AadharrequestId;
              this.ReturnDetail.AADHAARVerificationID = this.AadhaarDetail.AADHAARVerificationID;
              this.ReturnDetail.AadharVerificationStatus = this.AadhaarDetail.AadharVerificationStatus;
              this.ReturnDetail.AadharNoKyc = response.result.user_aadhaar_number;
              this.ReturnDetail.NameAsPerAadhaar = response.result.user_full_name;
              this.ReturnDetail.BirthDate = response.result.user_dob;
              this.ReturnDetail.Gender = response.result.user_gender;
              this.ReturnDetail.AadhaarNo = this.AadhaarDetail.AadhaarNo;
              //this.RegistrationDetail.Verification.AadharDetail.ParentName = response.result.user_parent_name;
              this.ReturnDetail.photo = "data:image/jpeg;base64," + response.result.user_profile_image;
              this.ReturnDetail.LocalAddress1 = response.result.user_address.house + "," + response.result.user_address.landmark + "," + response.result.user_address.loc;
              this.ReturnDetail.LocalAddress2 = response.result.user_address.street + "," + response.result.user_address.vtc + "," + response.result.user_address.dist + "," + response.result.user_address.state + "," + response.result.address_zip;
            } else {
              this.toast.show({ message: response.response_message, type: toastTypeEnum.danger });
              const modalRef = this.modalService.open(AlertWarningComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = "Aadhaar verification failed. Please try verifying through DigiLocker.";
              modalRef.result.then((result: any) => { });
            }
            this.isDisabled = false;
          },
          complete: () => { this.isDisabled = false; },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    } else {
      form.submitted = true;
    }
  }


  Confirm() {
    this.activeModal.close(this.ReturnDetail);
  }

  PanAadharBankDuplicate(SelectType: any, CheckValue: any) {
    this.isDisabled = true;
    this.employeeRegistration.PanAadharBankDuplicate({ CheckCompanyWise: true, SelectType: SelectType, FormType: this.EmpType, CheckValue: CheckValue, EmpMasterID: this.EmpMasterId }).subscribe({
      next: (response2) => {
        if (response2.Error_Code == '0') {
          if (SelectType == 'CheckAadhaar') {
            if (this.IsOkyc) {
              // OKYC
              this.verification.OkycOtpGen({ 'aadhaarNumber': this.AadhaarDetail.AadhaarNo }).subscribe({
                next: (response) => {
                  //response = JSON.stringify(response);
                  if (response.Error_Code) {
                    const modalRef = this.modalService.open(AlertWarningComponent, {
                      size: 'md',
                      backdrop: 'static',
                      centered: true,
                      windowClass: 'confirmation-modal'
                    });
                    modalRef.componentInstance.Message = "Aadhaar verification failed. Please try verifying through DigiLocker.";
                    modalRef.result.then((result: any) => { });
                  } else {
                    response = JSON.parse(response);
                    if (response.success && response.result.is_otp_sent && response.result.is_number_linked && response.result.is_aadhaar_valid) {
                      this.toast.show({ message: "OTP sent successfully", type: toastTypeEnum.success });
                      this.AadhaarDetail.AadharrequestId = response.request_id;
                      this.AadhaarDetail.SendOTP = true;
                      this.otpButtonDisable = true;

                      this.timingsixty = 60;
                      this.timer = interval(1000).subscribe((val) => {
                        this.timingsixty -= 1;
                        if (this.timingsixty == 0) {
                          this.otpButtonDisable = false;
                          this.timer.unsubscribe();
                        }
                      });
                    } else {
                      this.toast.show({ message: response.response_message, type: toastTypeEnum.danger });
                      const modalRef = this.modalService.open(AlertWarningComponent, {
                        size: 'md',
                        backdrop: 'static',
                        centered: true,
                        windowClass: 'confirmation-modal'
                      });
                      modalRef.componentInstance.Message = "Aadhaar verification failed. Please try verifying through DigiLocker.";
                      modalRef.result.then((result: any) => { });
                    }
                  }
                  this.isDisabled = false;
                },
                complete: () => { },
                error: (error) => {
                  if (this.IsOkyc) {
                    const modalRef = this.modalService.open(AlertWarningComponent, {
                      size: 'md',
                      backdrop: 'static',
                      centered: true,
                      windowClass: 'confirmation-modal'
                    });
                    modalRef.componentInstance.Message = "Aadhaar verification failed. Please try verifying through DigiLocker.";
                    modalRef.result.then((result: any) => { });
                  }
                  this.isDisabled = false;
                },
              });
            } else {
              //DGLOCKER
              this.verification.DigiDigiLocker_init({}).subscribe({
                next: (response) => {
                  response = JSON.parse(response);
                  if (response.data.success) {
                    const modalRef = this.modalService.open(AadhaarKYCDigilockerComponent, { size: 'lg', backdrop: 'static', });
                    modalRef.componentInstance.url = response.data.sdk_url;
                    modalRef.result.then(result => {
                      this.DigiResponseDigiLocker_Response(response.data.request_id);
                    });
                  } else {
                    this.toast.show({ message: response.response_message, type: toastTypeEnum.danger });
                  }
                  this.isDisabled = false;
                },
                complete: () => { },
                error: (error) => {
                  this.isDisabled = false;
                },
              });
            }
          }
        } else {
          this.toast.show({ message: response2.Error_Message, type: toastTypeEnum.warning });
          this.isDisabled = false;
        }

      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
        return "";
      },
    });
  }

  DigiResponseDigiLocker_Response(request_id: string) {
    this.verification.DigiResponseDigiLocker_Response({ 'RequestId': request_id }).subscribe({
      next: (response) => {
        if (response) {
          response = JSON.parse(response);
          if (!response.Error) {
            this.SaveVerification('Aadhaar Card KYC', request_id, JSON.stringify(response), true)
            if (response.data_json.KycRes.UidData) {
              this.ReturnDetail.AadharrequestId = request_id;
              this.ReturnDetail.AADHAARVerificationID = this.AadhaarDetail.AADHAARVerificationID;
              this.ReturnDetail.AadharVerificationStatus = this.AadhaarDetail.AadharVerificationStatus;
              this.ReturnDetail.AadharNoKyc = response.data_json.KycRes.UidData.uid;
              this.ReturnDetail.NameAsPerAadhaar = response.data_json.KycRes.UidData.Poi.name;
              this.ReturnDetail.BirthDate = response.data_json.KycRes.UidData.Poi.dob;
              this.ReturnDetail.Gender = response.data_json.KycRes.UidData.Poi.gender;
              this.ReturnDetail.AadhaarNo = this.AadhaarDetail.AadhaarNo;
              this.ReturnDetail.photo = "data:image/jpeg;base64," + response.data_json.KycRes.UidData.Pht;
              this.ReturnDetail.LocalAddress1 = response.data_json.KycRes.UidData.Poa.house + "," + response.data_json.KycRes.UidData.Poa.lm + "," + response.data_json.KycRes.UidData.Poa.loc;
              this.ReturnDetail.LocalAddress2 = response.data_json.KycRes.UidData.Poa.street + "," + response.data_json.KycRes.UidData.Poa.vtc + "," + response.data_json.KycRes.UidData.Poa.dist + "," + response.data_json.KycRes.UidData.Poa.state + "," + response.data_json.KycRes.UidData.Poa.pc;
            }
          } else {
            this.toast.show({ message: response.Error, type: toastTypeEnum.danger });
          }
        }
        // response = JSON.parse(response);
        // this.SaveVerification('Aadhaar Card KYC', this.AadhaarDetail.AadharrequestId, JSON.stringify(response), response.success);
        // if (response.success) {
        //   this.ReturnDetail.AadharrequestId = this.AadhaarDetail.AadharrequestId;
        //   this.ReturnDetail.AADHAARVerificationID = this.AadhaarDetail.AADHAARVerificationID;
        //   this.ReturnDetail.AadharVerificationStatus = this.AadhaarDetail.AadharVerificationStatus;
        //   this.ReturnDetail.AadharNoKyc = response.result.user_aadhaar_number;
        //   this.ReturnDetail.NameAsPerAadhaar = response.result.user_full_name;
        //   this.ReturnDetail.BirthDate = response.result.user_dob;
        //   this.ReturnDetail.Gender = response.result.user_gender;
        //   this.ReturnDetail.AadhaarNo = this.AadhaarDetail.AadhaarNo;
        //   //this.RegistrationDetail.Verification.AadharDetail.ParentName = response.result.user_parent_name;
        //   this.ReturnDetail.photo = "data:image/jpeg;base64," + response.result.user_profile_image;
        //   this.ReturnDetail.LocalAddress1 = response.result.user_address.house + "," + response.result.user_address.landmark + "," + response.result.user_address.loc;
        //   this.ReturnDetail.LocalAddress2 = response.result.user_address.street + "," + response.result.user_address.vtc + "," + response.result.user_address.dist + "," + response.result.user_address.state + "," + response.result.address_zip;
        // } else {
        //   this.toast.show({ message: response.response_message, type: toastTypeEnum.danger });
        // }
        this.isDisabled = false;
      },
      complete: () => { this.isDisabled = false; },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  SaveVerification(mVerificationType: string, mRequest: any, mResponse: any, Store: any) {
    this.employeeRegistration.SaveVerification({ mVerificationType: mVerificationType, mRequest: mRequest, mResponse: mResponse, EmpMasterId: this.EmpMasterId }).subscribe({
      next: (response) => {
        if (mVerificationType == 'Aadhaar Card KYC' && Store) {
          this.AadhaarDetail.AADHAARVerificationID = response.mVerificationID;
          this.AadhaarDetail.AadharVerificationStatus = 'Verified';
          this.ReturnDetail.AADHAARVerificationID = this.AadhaarDetail.AADHAARVerificationID;
          this.ReturnDetail.AadharVerificationStatus = this.AadhaarDetail.AadharVerificationStatus;
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  ResendAadharOTP() {
    this.PanAadharBankDuplicate('CheckAadhaar', this.AadhaarDetail.AadhaarNo);
  }

  close() {
    this.activeModal.close();
  }
}
